import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, subtitle, image, testId }) {
  return (
    <section data-testid={testId || "page-hero"} className="relative pt-[120px] md:pt-[160px] pb-20 md:pb-28 overflow-hidden bg-shramik-greenLight/50">
      <div className="orb bg-shramik-green/25 w-[520px] h-[520px] -top-40 -right-40" />
      <div className="orb bg-shramik-blue/20 w-[420px] h-[420px] -bottom-40 -left-20" />
      <div className="container-page relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            {eyebrow && <div className="overline mb-5">{eyebrow}</div>}
            <h1 className="font-display font-light text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter text-shramik-ink text-balance">
              {title}
            </h1>
            {subtitle && <p className="mt-6 text-lg md:text-xl text-slate-600 max-w-2xl leading-relaxed">{subtitle}</p>}
          </motion.div>
          {image && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, delay: 0.15 }}
              className="lg:col-span-5"
            >
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
                <img src={image} alt="" loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-shramik-ink/40 to-transparent" />
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
}
